import { ILayoutElement } from "../../_types/interfaces";

export const firstLinks: Array<ILayoutElement> = [
    {
        link: '/updater',
        icon: 'i:arrow_downward',
        text: 'Обновления',
    },
    {
        link: '/settings',
        icon: 'i:build',
        text: 'Настройки',
    },
    {
        link: '/services',
        icon: 'i:settings',
        text: 'Сервисы',
    },
    {
        link: '/plugins',
        icon: 'i:extension',
        text: 'Плагины',
    },
];